import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export type ProfileDetail = {
    aflTeamOfSupport: string | null;
    bblTeamOfSupport: string | null;
    specialInterests: string[] | null;
}

type ProfileApiReturn = {
    isSuccess: boolean;
    data: ProfileDetail;
    errorMessages: string | null;
    exception: string | null;
}

const useProfileQuery = (): UseQueryResult<ProfileApiReturn> => {
    const endpoint = '/api/Members/current/profile';
    // use this to simulate complete data using dummy json
    // const endpoint = '/assets/data/profile-info.json';

    const profileQuery = useQuery<ProfileApiReturn>({
        queryKey: ['profileQuery'],
        queryFn: async() => {
            const response = await fetch(endpoint);
            if (!response.ok) {
                throw new Error(`Failed to fetch profile: ${response.status} ${response.statusText}`);
            }
            return response.json();
        },
        staleTime: Number.POSITIVE_INFINITY,
    });

    return profileQuery;
};

export default useProfileQuery;
